import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import PropTypes from "prop-types";
import PromptForm from "./PropmtForm";
import LoadingScreen from "./LoadingScreen";

class DialogOTP extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sessionId: this.generateSessionId(),
      forceReset: true,
    };
  }

  generateSessionId = () => {
    return Math.random().toString(36).substring(2, 9);
  };

  handleOpen = () => {
    // Generar un nuevo sessionId cada vez que se abre el diálogo
    this.setState({
      sessionId: this.generateSessionId(),
      forceReset: true, // asegurar reinicio del contador
    });
  };

  render() {
    const {
      onCloseDialogOTP,
      openDialogOTP,
      OTPSubmit,
      loading,
      handleChangeInputOtp,
      onKeyPress,
      timeLifeToken,
      length,
      refreshToken,
    } = this.props;

    return (
      <Dialog
        open={openDialogOTP}
        onClose={onCloseDialogOTP}
        fullWidth
        maxWidth="xs"
        disableEscapeKeyDown
        PaperProps={{ style: { borderRadius: 20 } }}
        onEntered={this.handleOpen} // se dispara al abrir
      >
        <DialogContent style={{ padding: 20 }}>
          <PromptForm
            {...this.state} // sessionId y forceReset
            key={this.state.sessionId}
            label="Digite su código"
            onSubmit={OTPSubmit}
            cancelPrompt={onCloseDialogOTP}
            handleChangeInputOtp={handleChangeInputOtp}
            onKeyPress={onKeyPress}
            loading={loading}
            refreshToken={refreshToken}
            timeLifeToken={timeLifeToken}
            length={length}
          />
        </DialogContent>
        <LoadingScreen open={loading} />
      </Dialog>
    );
  }
}

DialogOTP.propTypes = {
  onCloseDialogOTP: PropTypes.func.isRequired,
  openDialogOTP: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  timeLifeToken: PropTypes.number.isRequired,
};

export default DialogOTP;
